document.addEventListener('DOMContentLoaded', function() {
  // Find all slideshow elements
  const slideshows = document.querySelectorAll('slide-show');
  
  slideshows.forEach(function(slideshow) {
    // Initialize Hammer.js on each slideshow
    const hammer = new Hammer(slideshow);
    
    // Configure horizontal swipe recognition
    hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
    
    // Handle swipe left (next slide)
    hammer.on('swipeleft', function() {
      // Find and click the next button or programmatically advance the slide
      const slides = slideshow.querySelectorAll('.slideshow__slide');
      const currentSlide = slideshow.querySelector('.slideshow__slide:not([hidden])');
      const currentIndex = Array.from(slides).indexOf(currentSlide);
      const nextIndex = (currentIndex + 1) % slides.length;
      
      // Trigger slide change
      const pageDots = slideshow.querySelectorAll('.slideshow__progress-bar');
      if (pageDots[nextIndex]) {
        pageDots[nextIndex].click();
      }
    });
    
    // Handle swipe right (previous slide)
    hammer.on('swiperight', function() {
      // Find and click the previous button or programmatically go to previous slide
      const slides = slideshow.querySelectorAll('.slideshow__slide');
      const currentSlide = slideshow.querySelector('.slideshow__slide:not([hidden])');
      const currentIndex = Array.from(slides).indexOf(currentSlide);
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      
      // Trigger slide change
      const pageDots = slideshow.querySelectorAll('.slideshow__progress-bar');
      if (pageDots[prevIndex]) {
        pageDots[prevIndex].click();
      }
    });
  });
});